/*
 * File: /src/services/referralServices.js
 * Created Date: Sunday June 6th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 6th June 2021 8:43:06 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */
import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_RESERVATIONS_PATH } from '../constants';

export default {
  /**
   * Fetch Reservations
   * @param {number} after_id
   * @param {number} limit
   * @param {number} filter
   * @param {number} sort
   * @returns ReservationPage
   */
  fetchReservations(after_id, limit, filter, sort, tags) {
    const params = {
      limit: limit ? limit : 100,
      filter: filter,
      sort: sort,
      tags: tags,
    };
    if (after_id) {
      params.after_id = after_id;
    }
    return authedAxios
      .get(AD_BASE_RESERVATIONS_PATH, {
        params: params,
      })
      .then((r) => r.data);
  },

  /**
   *
   *
   * @returns
   */
  fetchReservationCount() {
    return authedAxios.get(AD_BASE_RESERVATIONS_PATH + 'count');
  },

  /**
   * Fetch Reservation by Id
   */
  fetchReservationsById(id) {
    return authedAxios.get(AD_BASE_RESERVATIONS_PATH + id);
  },

  /**
   * Fetch Reservation by Contact Id
   */
  fetchReservationsByCustomerId(id) {
    return authedAxios.get(AD_BASE_RESERVATIONS_PATH + 'contact/' + id);
  },

  /**
   * Fetch Reservation Types
   */
  fetchReservationTypes() {
    return authedAxios.get(AD_BASE_RESERVATIONS_PATH + 'reservation-types');
  },

  /**
   * Fetch the reservations that sit next to a gap in their unit's calendar.
   *
   * @param {Date} startDate first day of the search window, not in the past
   * @param {Date} endDate last day of the window, at most 30 days from start
   * @param {string} timezone IANA zone the gap nights are counted in
   * @param {number} minGap smallest gap to report, 0 - 30 nights
   * @param {string} gapSide 'arrival' or 'departure', side of the reservation
   * @returns GapNightReservation[]
   */
  fetchGapNights(startDate, endDate, timezone, minGap, gapSide) {
    return authedAxios.get(AD_BASE_RESERVATIONS_PATH + 'gap-night', {
      params: {
        startDate: startDate,
        endDate: endDate,
        timezone: timezone,
        minGap: minGap,
        gapSide: gapSide,
      },
    });
  },
  latestByContactId(contactId) {
    return authedAxios.get(AD_BASE_RESERVATIONS_PATH + 'contact/' + contactId + '/latest');
  },
  loadTags(reservationId) {
    return authedAxios.get(AD_BASE_RESERVATIONS_PATH + reservationId + '/tags');
  },
  setTags(reservationId, tagIds) {
    return authedAxios.put(AD_BASE_RESERVATIONS_PATH + reservationId + '/tags/', tagIds);
  },

};
